import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { DtbPayPage } from "./dtb-pay";

@NgModule({
  declarations: [DtbPayPage],
  imports: [IonicPageModule.forChild(DtbPayPage)],
})
export class DtbPayPageModule {}



// WEBPACK FOOTER //
// ./src/pages/dtb-pay/dtb-pay.module.ts